import { BackendReport, BauteilEntry, BauteilWithReports, FrontendReport } from "@partikelart/portal/shared-typing";

import reportData432 from "./mock-reports/123432.json";
import reportData433 from "./mock-reports/123433.json";
import reportData434 from "./mock-reports/123434.json";
import reportData435 from "./mock-reports/123435.json";
import reportData436 from "./mock-reports/123436.json";
import reportData437 from "./mock-reports/123437.json";
import reportData438 from "./mock-reports/123438.json";
import reportData333 from "./mock-reports/333333.json";

const allJSONReports = [
	...reportData432,
	...reportData433,
	...reportData434,
	...reportData435,
	...reportData436,
	...reportData437,
	...reportData438,
];
const testdata = [...reportData333];
export function getAllReports() {
	const allReports: BackendReport[] = allJSONReports.map((report) => {
		return {
			...report,
			woFNM_1_AreaCircle: 100,
			woFNM_2_AreaCircle: 80,
			woFNM_3_AreaCircle: 60,
			woFNM_4_AreaCircle: 40,
			woFNM_5_AreaCircle: 20,
			Met_1_AreaCircle: 100,
			Met_2_AreaCircle: 80,
			Met_3_AreaCircle: 60,
			Met_4_AreaCircle: 40,
			Met_5_AreaCircle: 20,
			Date_of_arrival: new Date(report.Date_of_arrival),
			Date_of_Extraction: new Date(report.Date_of_Extraction),
			Date_of_Analysis: new Date(report.Date_of_Analysis),
			artnr: Number(report.artnr),
			is_fallback: false,
		} as BackendReport;
	});
	return allReports;
}
export function getReportById(url: string) {
	const analysis_no = Number(url.split("/").pop());
	const report = allJSONReports.find((report) => report.analysis_int == analysis_no);
	return report;
}

export function reportPartOverviewData(url: string) {
	const segments = url.split("/");
	const artnr = Number(segments[5]);

	const relevantReports = getAllReports().filter((report) => report.artnr == artnr);
	return relevantReports.map((report) => {
		if (localStorage.getItem("comment/" + report.Analysis_No)) {
			return {
				...report,
				Comment: localStorage.getItem("comment/" + report.Analysis_No),
			};
		}
		return report;
	});
}

export function getBauteilbildForReport(url: string) {
	// This function includes all Bauteilbild functions and needs to be renamed in the future
	if (url.includes("artnr")) {
		const artnr = url.split("/").pop();
		return {
			imageurl: `/assets/images/${artnr}.jpg`,
		};
	}
	const artnr = allJSONReports.find((report) => report.analysis_int == Number(url.split("/").pop())).artnr;
	return {
		url: `/assets/images/${artnr}.jpg`,
	};
}
export function getGridData(url: string): BauteilEntry[] {
	const datafor12345 = [
		{
			artnr: "5123432",
			artsuch: "Scheibe",
			anzahl: 17,
			imgurl: "/assets/images/5123432.jpg",
			zeichindex: "Scheibe XY",
			zeichnr: "Scheibe",
			katseite: "",
		},
		{
			artnr: "5123433",
			artsuch: "Blech",
			anzahl: 10,
			imgurl: "/assets/images/5123433.jpg",
			zeichindex: "Blech AB",
			zeichnr: "Blech",
			katseite: "",
		},
		{
			artnr: "5123434",
			artsuch: "Flansch",
			anzahl: 41,
			imgurl: "/assets/images/5123434.jpg",
			zeichindex: "Flansch DE",
			zeichnr: "Flansch",
			katseite: "",
		},
		{
			artnr: "5123435",
			artsuch: "Getriebe",
			anzahl: 25,
			imgurl: "/assets/images/5123435.jpg",
			zeichindex: "Getriebe FF mit inn. Titan ABC und außen Alu DBF",
			zeichnr: "Getriebe mit einer Titanlegierung innerhalb des Rings",
			katseite: "",
		},
	];
	const dataFor12346 = [
		{
			artnr: "5123436",
			artsuch: "Stecker",
			anzahl: 18,
			imgurl: "/assets/images/5123436.jpg",
			zeichindex: "Stecker Z1",
			zeichnr: "Stecker",
			katseite: "",
		},
		{
			artnr: "5123437",
			artsuch: "Schiene",
			anzahl: 10,
			imgurl: "/assets/images/5123437.jpg",
			zeichindex: "Schiene Z6",
			zeichnr: "Schiene",
			katseite: "",
		},
		{
			artnr: "5123438",
			artsuch: "Deckel",
			anzahl: 15,
			imgurl: "/assets/images/5123438.jpg",
			zeichindex: "Deckel Z2",
			zeichnr: "Deckel",
			katseite: "",
		},
	];
	if (url.includes("12345")) {
		return datafor12345;
	}
	if (url.includes("12346")) {
		return dataFor12346;
	}
	return [];
}
export function getBauteilWithReportData(): BauteilWithReports[] {
	const data = [
		{
			artnr: "5123432",
			artsuch: "Scheibe",
			anzahl: 17,
			imgurl: "/assets/images/5123432.jpg",
			zeichindex: "Scheibe",
			zeichnr: "",
			katseite: "",
			reports: getAllReports()
				.filter((report) => report.artnr == 5123432)
				.map((report) => {
					return new FrontendReport(report);
				}),
			selected: false,
		},
		{
			artnr: "5123433",
			artsuch: "Blech",
			anzahl: 10,
			imgurl: "/assets/images/5123433.jpg",
			zeichindex: "Blech",
			zeichnr: "",
			katseite: "",
			reports: getAllReports()
				.filter((report) => report.artnr == 5123433)
				.map((report) => {
					return new FrontendReport(report);
				}),
			selected: false,
		},
		{
			artnr: "5123434",
			artsuch: "Flansch",
			anzahl: 41,
			imgurl: "/assets/images/5123434.jpg",
			zeichindex: "Flansch",
			zeichnr: "",
			katseite: "",
			reports: getAllReports()
				.filter((report) => report.artnr == 5123434)
				.map((report) => {
					return new FrontendReport(report);
				}),
			selected: false,
		},
		{
			artnr: "5123435",
			artsuch: "Getriebe",
			anzahl: 25,
			imgurl: "/assets/images/5123435.jpg",
			zeichindex: "Getriebe",
			zeichnr: "",
			katseite: "",
			reports: getAllReports()
				.filter((report) => report.artnr == 5123435)
				.map((report) => {
					return new FrontendReport(report);
				}),
			selected: false,
		},
		{
			artnr: "5123436",
			artsuch: "Stecker",
			anzahl: 18,
			imgurl: "/assets/images/5123436.jpg",
			zeichindex: "Stecker",
			zeichnr: "",
			katseite: "",
			reports: getAllReports()
				.filter((report) => report.artnr == 5123436)
				.map((report) => {
					return new FrontendReport(report);
				}),
			selected: false,
		},
		{
			artnr: "5123437",
			artsuch: "Schiene",
			anzahl: 10,
			imgurl: "/assets/images/5123437.jpg",
			zeichindex: "Schiene",
			zeichnr: "",
			katseite: "",
			reports: getAllReports()
				.filter((report) => report.artnr == 5123437)
				.map((report) => {
					return new FrontendReport(report);
				}),
			selected: false,
		},
		{
			artnr: "5123438",
			artsuch: "Deckel",
			anzahl: 15,
			imgurl: "/assets/images/5123438.jpg",
			zeichindex: "Deckel",
			zeichnr: "",
			katseite: "",
			reports: getAllReports()
				.filter((report) => report.artnr == 5123438)
				.map((report) => {
					return new FrontendReport(report);
				}),
			selected: false,
		},
	];
	return data as BauteilWithReports[];
}
